module.exports = __webpack_public_path__ + "static/media/left-direction-img.183fb271.svg";